export default __webpack_public_path__ + "static/media/verify2.9b689965.svg";